import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import JsxHelper from '../Helpers/JsxHelper';
import FigmaBadge from '../Elements/FigmaBadge';
import RedirectLinkComponent from '../Elements/RedirectLinkComponent';

export default class FraudToolBaseEvaluatorItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Shopper Id',
        orderById: 'EvSassieId',
        data: FraudToolBaseEvaluatorItem.idFunction,
        minWidth: '100px',
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      { label: 'Shopper Name', orderById: 'LastName', data: (item) => `${item.EvLastName}, ${item.EvFirstName}` },
      { label: 'Profile Email', orderById: 'EvEmail', data: (item) => JsxHelper.MailTo(item.EvEmail) },
      { label: 'Account Status', orderById: 'EvStatus', data: 'EvStatus', minWidth: '120px' },
      {
        // label: 'FW Office',
        // The country's evaluator office, as the fraud hit lists show it - not the fieldwork office (CD-5666).
        label: 'Ev. Pym Office',
        orderById: 'EvCountryEvaluatorOfficeName',
        data: 'EvCountryEvaluatorOfficeName',
      },
      { label: 'Country', orderById: 'EvCountry', data: 'CountryName' },
      {
        label: 'Agency?',
        orderById: 'EvIsAgency',
        data: FraudToolBaseEvaluatorItem.getIsActiveCellContent,
        minWidth: 50,
      },
    ];
  }

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        path='evaluator'
        tooltipText={item.EvSassieId}
        isFigmaStyle={true}
        text={item.EvSassieId}
        keyValuePairs={[{ key: 'Id', value: item.EvSassieId }]}
      />
    );
  }

  static getIsActiveCellContent(item) {
    return (
      <div className='pointer'>
        {
          <FigmaBadge
            Active={item.EvIsAgency}
            ActiveText='Yes'
            InactiveText='No'
            width={50}
          />
        }
      </div>
    );
  }
}
